import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Mascot } from "@/components/Mascot";

const inline = (s) => s.split(/(\*\*[^*]+\*\*)/).map((p, i) => (p.startsWith("**") ? <strong key={i} className="text-gray-800">{p.slice(2, -2)}</strong> : p));

const Markdown = ({ text }) => (
  <div className="space-y-1.5 text-sm text-gray-600 leading-relaxed">
    {text.split("\n").map((l, i) => {
      if (l.startsWith("#")) return <h4 key={i} className="font-heading text-lg font-semibold text-pink-500 pt-3">{l.replace(/^#+\s*/, "")}</h4>;
      if (/^\s*[-*]\s/.test(l) || /^\s*\d+\.\s/.test(l)) return <p key={i} className="pl-4 relative before:content-['•'] before:absolute before:left-0 before:text-pink-400">{inline(l.replace(/^\s*([-*]|\d+\.)\s/, ""))}</p>;
      return l.trim() ? <p key={i}>{inline(l)}</p> : null;
    })}
  </div>
);

export default function InsightsTab() {
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/ai/insights");
      setText(data.insight);
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-4" data-testid="duitku-ai">
      <div className="card-soft flex flex-col sm:flex-row items-center gap-4 bg-gradient-to-br from-sky-50 to-pink-50">
        <Mascot pose={busy ? "read" : "happy"} className="w-28" />
        <div className="flex-1 text-center sm:text-left">
          <h3 className="font-heading text-xl font-semibold text-gray-800">Saran keuangan dari Baby Monster</h3>
          <p className="text-sm text-gray-500 mt-1">Berdasarkan pemasukan, pengeluaran, tabungan & target 90 hari terakhir.</p>
        </div>
        <Button onClick={run} disabled={busy} className="rounded-full h-11 px-6" data-testid="ai-insight-generate-btn">
          {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Sparkles className="w-4 h-4 mr-2" />}
          {busy ? "Lagi mikir..." : text ? "Analisis ulang" : "Analisis sekarang"}
        </Button>
      </div>
      {text && (
        <div className="card-soft" data-testid="ai-insight-card">
          <Markdown text={text} />
        </div>
      )}
    </div>
  );
}
